import Container from './container'

export default Container



// WEBPACK FOOTER //
// ./src/gov-registrations/details/index.js